

import React  from 'react';
import { FormattedMessage } from 'react-intl';
import { Link , hashHistory } from "react-router";

import Layout from '../components/layouts/blank-page.js';
import SingleInput from '../components/inputs/single.input.js';
import Authentication from '../services/authenticate-services.js';
import AuthenticationStore from '../store/authentication-store.js';
import InternationalizationService from '../services/internationalization-service.js';
export default class LoginComponent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {isAuthenticated:AuthenticationStore.isAuthenticated() , username: '', password: '' , loaded:true}
    }

    componentWillMount(){
        AuthenticationStore.on("CHANGE" , () => {
            this.setState({
                isAuthenticated:AuthenticationStore.isAuthenticated()
            });
        });
    }

    handleUsernameChange(e) {
        this.setState({ username: e.target.value });
    }

    handlePasswordChange(e) {
        this.setState({ password: e.target.value });
    }

    handleSubmit(event) {
        Authentication.authenticate(this.state.username , this.state.password);
    }

    redirect(){
        sessionStorage.getItem("resources_authentication");

        if(!this.state.isAuthenticated &&  sessionStorage.getItem("resources_authentication") == true)
            return window.location.href = window.location.origin + "/resources/#/LoginScreen";

        if(!this.state.isAuthenticated) return null;


        sessionStorage.setItem("admin_authentication", true);
        var location = this.props.location;

        if(location.state && location.state.nextPathname)
        {
            hashHistory.push(location.state.nextPathname);
        }
        else
        {
            hashHistory.push('/dashboard')
        }

    }

    render(){
        this.redirect();
        return (<Layout><div className="login" >
            <div className={"l-block animate toggled"} id="l-login">
                <div className="lb-header palette-Languagenut bg">
                    <center><img src="img/logos/languagenut/no-text-logo.png"/></center>logos
                </div>
                <div className="lb-body">
                    <div className="form-group fg-float">
                        <div className="fg-line">
                            <SingleInput
                                inputType={'text'}
                                title={'Full name'}
                                name={'name'}
                                toggled={false}
                                content={this.state.username}
                                labelTranslationUID='ui-22'
                                labelName='Username'
                                controlFunc={this.handleUsernameChange.bind(this)}
                                placeholder={'Type first and last name here'} />
                        </div>
                    </div>
                    <div className="form-group fg-float">
                        <div className="fg-line">
                            <SingleInput
                                inputType={'text'}
                                title={'Full name'}
                                name={'name'}
                                toggled={false}
                                content={this.state.password}
                                labelTranslationUID='ui-23'
                                labelName='Password'
                                controlFunc={this.handlePasswordChange.bind(this)}
                                placeholder={'Type first and last name here'} />
                        </div>
                        <div className="fg-line">
                            <Link to="/forgotten-password"  className="palette-Branding link"><FormattedMessage id={ 'ui-26' } defaultMessage={ 'Forgotten Password!' }/></Link>
                        </div>
                    </div>
                    <button onClick={this.handleSubmit.bind(this)} className="palette-Branding Green btn btn-primary btn-lg btn-block" ><FormattedMessage id={ 'ui-13' } defaultMessage={ 'Login' }/></button>
                </div>
            </div>
        </div></Layout>)
    }
}


// WEBPACK FOOTER //
// ./src/screens/login.js